import type { RouteRecordRaw } from 'vue-router';
import { STUDIO_ADMIN_CRUD, STUDIO_CRUD } from '@core/models/permissions';
import { permissionRouteGuard } from '@core/route-guards';

export const JOB_GENERAL_SETTINGS = 'jobsettings-general';
export const JOB_PREORDER_SETTINGS = 'jobsettings-preorder';
export const JOB_PREORDER_FIELDS = 'jobsettings-preorder-fields';
export const JOB_GALLERY_SETTINGS = 'jobsetting-gallery';
export const JOB_SUBJECT_OVERVIEW = 'jobsettings-overview';
export const JOB_OVERVIEW = 'job-overview';
export const JOB_PACKAGES = 'job-packages';
export const JOB_PACKAGES_LISTING = 'job-packages-listing';
export const JOB_PACKAGES_GREENSCREENS = 'job-packages-greenscreens';
export const JOB_SUBJECTS = 'job-subjects';
export const JOB_SUBJECTS_LISTING = 'job-subjects-listing';
export const JOB_SUBJECTS_GROUPS = 'job-subjects-groups';
export const JOB_ORDERS = 'job-orders';
export const JOB_PROMOTIONS = 'job-promotions';
export const JOB_ORDERS_PREPAY = 'job-orders-prepay';
export const JOB_ORDERS_BATCH = 'job-orders-batch';
export const JOB_ORDERS_INDIVIDUAL = 'job-orders-individual';
export const JOB_ORDERS_SUBMITTED = 'job-orders-submitted';
export const JOB_IMAGE_MATCHING = 'job-image-matching';

const BASE = '/admin/studios/:studioId/jobs/:jobId';

export const jobEditorLinks: RouteRecordRaw[] = [
  {
    path: ':jobId',
    component: () => import('@apps/job-editor/layouts/JobEditorLayout.vue'),
    beforeEnter: [permissionRouteGuard([STUDIO_CRUD, STUDIO_ADMIN_CRUD])],
    children: [
      {
        name: JOB_OVERVIEW,
        path: 'overview',
        component: () => import('@apps/job-editor/pages/JobOverviewPage.vue'),
      },
      {
        path: 'settings',
        component: () => import('@apps/job-editor/pages/Settings/JobSettingsPage.vue'),
        children: [
          {
            name: JOB_GENERAL_SETTINGS,
            path: '',
            alias: 'general-settings',
            component: () => import('@apps/job-editor/pages/Settings/components/GeneralSettings.vue'),
          },
          {
            name: JOB_PREORDER_SETTINGS,
            path: 'preorder',
            component: () => import('@apps/job-editor/pages/Settings/components/PreorderSettings.vue'),
          },
          {
            name: JOB_PREORDER_FIELDS,
            path: 'prefields',
            component: () => import('@apps/job-editor/pages/Settings/components/PreorderCustomFields.vue'),
          },
          {
            name: JOB_GALLERY_SETTINGS,
            path: 'gallery',
            component: () => import('@apps/job-editor/pages/Settings/components/GallerySettings.vue'),
          },
        ],
      },
      {
        name: JOB_PACKAGES,
        path: 'packages',
        component: () => import('@apps/job-editor/pages/Packages/JobPackagesPage.vue'),
        children: [
          {
            name: JOB_PACKAGES_LISTING,
            path: '',
            alias: `listing`,
            component: () => import('@apps/job-editor/pages/Packages/components/PackageListing.vue'),
          },
          {
            name: JOB_PACKAGES_GREENSCREENS,
            path: 'greenscreens',
            component: () => import('@apps/job-editor/pages/Packages/components/GreenScreenListing.vue'),
          },
        ],
      },
      {
        name: JOB_SUBJECTS,
        path: 'subjects',
        component: () => import('@apps/job-editor/pages/Subjects/SubjectsPage.vue'),
        children: [
          {
            name: JOB_SUBJECTS_LISTING,
            path: '',
            alias: `listing`,
            component: () => import('@apps/job-editor/pages/Subjects/components/SubjectListing.vue'),
          },
          {
            path: 'groups',
            name: JOB_SUBJECTS_GROUPS,
            component: () => import('@apps/job-editor/pages/Subjects/components/GroupListing.vue'),
          },
          {
            name: JOB_SUBJECT_OVERVIEW,
            path: ':subjectId',
            component: () => import('@apps/job-editor/pages/Subjects/SubjectOverviewPage.vue'),
          },
        ],
      },
      {
        name: JOB_IMAGE_MATCHING,
        path: 'image-matching',
        component: () => import('@apps/job-editor/pages/Image-Matching/ImageMatchingPage.vue'),
      },
      {
        name: JOB_PROMOTIONS,
        path: 'promotions',
        component: () => import('@apps/job-editor/pages/Promotions/PromotionsPage.vue'),
      },
      {
        name: JOB_ORDERS,
        path: 'orders',
        component: () => import('@apps/job-editor/pages/Orders/JobOrdersPage.vue'),
        children: [
          {
            name: JOB_ORDERS_PREPAY,
            path: '',
            alias: `orders`,
            component: () => import('@apps/job-editor/pages/Orders/PrepayOrders.vue'),
          },
          {
            name: JOB_ORDERS_BATCH,
            path: 'batch',
            component: () => import('@apps/job-editor/pages/Orders/BatchOrders.vue'),
          },
          {
            name: JOB_ORDERS_INDIVIDUAL,
            path: 'individual',
            component: () => import('@apps/job-editor/pages/Orders/IndividualOrders.vue'),
          },
          {
            name: JOB_ORDERS_SUBMITTED,
            path: 'submitted',
            component: () => import('@apps/job-editor/pages/Orders/SubmittedOrders.vue'),
          },
        ],
      },
    ],
  },
];

export const baseRoutes: RouteRecordRaw[] = [
  {
    path: `${BASE}/orders`,
    children: [
      {
        path: 'camera-cards',
        name: 'camera-cards',
        beforeEnter: [permissionRouteGuard([STUDIO_CRUD, STUDIO_ADMIN_CRUD])],
        component: () => import('./pages/Orders/CameraCardsPrintPage.vue'),
      },
      {
        path: 'print',
        name: 'roster-print',
        beforeEnter: [permissionRouteGuard([STUDIO_CRUD, STUDIO_ADMIN_CRUD])],
        component: () => import('./pages/Orders/RosterPrintPage.vue'),
      },
    ],
  },
];
